import MaskedView from './MaskedView';

export default MaskedView;
